import MaintenanceModeToggle from "modules/brands/components/MaintenanceModeToggle";
import FlexCenter from "shared/components/Layout/components/FlexCenter";

const MaintenanceModeView = () => {
  return (
    <FlexCenter marginBottom="0.5rem">
      <MaintenanceModeToggle />
    </FlexCenter>
  );
};

export default MaintenanceModeView;
